/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Title_2Inputs */

const en_blog_title_2 = /** @type {(inputs: Blog_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`at useful systems.`)
};

const lv_blog_title_2 = /** @type {(inputs: Blog_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`noderīgas sistēmas.`)
};

/**
* | output |
* | --- |
* | "at useful systems." |
*
* @param {Blog_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_title_2 = /** @type {((inputs?: Blog_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_title_2(inputs)
	return en_blog_title_2(inputs)
});